module.exports = __webpack_public_path__ + "static/img/pay_selected.3c11144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_selected.png
// module id = dman
// module chunks = 1